import React, { useEffect, useState } from "react";
import moment from "moment";
import { exportData } from "../../utils/helpers";
import VGMDataTable from "../common/tables/VGMDataTable";
import { getVGMData } from "../../services/VGMService";
import { VGMGetDataFilter } from "../../utils/dataFilter";
import store from "../../store/Store";
import * as actionType from "../../store/ActionTypes";
import { dispatcher } from "../../store/storeHelpers";
import { filter } from "lodash";
import noDataAvailable from "../../assets/img/noDataAvailable.png";
import Counters from "../common/Counters";
import { getJDPersonName } from "../../services/VGMService";
import { PulseLoader } from "react-spinners";

function VGMData() {
	const [loader, setLoader] = useState(false);
	const [data, setData] = useState([]);
	const [date, setDate] = useState({
		fromdate: moment().format("YYYY-MM-DD"),
		todate: moment().format("YYYY-MM-DD"),
	});
	const [newSelectedFlatRows, setNewSelectedFlatRows] = useState([]);
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [personName, setPersonName] = useState([]);

	const resetStorage = () => {
		setData([]);
	};

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setData(Object.values(store.getState().add_VGM_Data));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "VGM", View: 1 }).length > 0) {
			setFilteredUserAccessData(filter(userData, { MenuName: "VGM", View: 1 }));
		}
	}, [userData]);

	useEffect(() => {
		async function getPlan() {
			resetStorage();
			setLoader(true);
			try {
				setNoDataState(false);
				const response = await getVGMData(date);
				dispatcher(actionType.VGM_DATA_LOAD, VGMGetDataFilter(response.data));
				setLoader(false);
			} catch (error) {
				setLoader(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
					setData([])
				}
			}
		}
		getPlan();
	}, [date]);

	useEffect(() => {
		const JdPersonName = async () => {
			const response = await getJDPersonName();

			setPersonName(response.data);
		};
		JdPersonName();
	}, []);
	const dataExportHandler = () => {
		exportData(
			data.map((item) => {
				return {
					Module: item["DataOf"],
					Shipper_Name: item["shippername"],
					Shipper_Lic_No: item["Shipper_Lic_No"],
					Shipper_Authorised_Name: item["Shipper_Authorised_Name"],
					Mobile_Number: item["Mobile_Number"],
					Container_No: item["Container_Number"],
					Container_Size: item["Container_Type"],
					Container_Weight: item["Container_Weight"],
					Weibridge_Address: item["Weibridge_Address"],
					Weibridge_Reg_No: item["Weibridge_Reg_No"],
					Container_Mass: item["Container_Mass"],
					Weighing_Date:
						item["Weighing_Date"] === "Invalid date"
							? ""
							: moment(item["Weighing_Date"]).format("DD-MM-YYYY HH:mm A"),
					Weighing_Slip_No: item["Weighing_Slip_No"],
					VGM_Type: item["VGM_Type"],
					Remarks: item["Remarks"],
					VGMDoc: item["VGMDoc"],
				};
			}),
			`VGM Data ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	return (
		<>
			<div className="flex-row mb-12 counterHeaderResponsive">
				<h1>VGM Data</h1>
				<Counters
					counter={{ Total: data.length }}
					label={["Total"]}
					styleData="df_dailyCounter"
				/>
			</div>
			{loader && (
				<PulseLoader
					color="#007bff"
					size="20px"
					margin="10px"
					style={{ position: "absolute", top: "50vh", left: "45%" }}
				/>
			)}
			{!loader && noDataState && (
				<img
					src={noDataAvailable}
					alt="notAvailableImg"
					className="noDataFoundImg"
					// style={{ marginLeft: "-2%" }}
				/>
			)}
			{/* <button onClick={downloadPDF}>Download PDF</button> */}
			{!loader && (
				<VGMDataTable
					tableData={data}
					setTableData={setData}
					date={date}
					setDate={setDate}
					dataExportHandler={dataExportHandler}
					subModule="Daily"
					type={"Daily"}
					newSelectedFlatRows={newSelectedFlatRows}
					setNewSelectedFlatRows={setNewSelectedFlatRows}
					filteredUserAccessData={filteredUserAccessData}
					noDataState={noDataState}
					setNoDataState={setNoDataState}
					personName={personName}
				/>
			)}
		</>
	);
}

export default VGMData;
